import type { EventConfig } from './configTypes';
import votesGeneric from './votes-generic';

const configs: Record<string, EventConfig | undefined> = {
  ['votes-generic']: votesGeneric,
};

export const eventConfig = configs[import.meta.env.VITE_CLIENT_ID];
